import { createAction, props } from "@ngrx/store";
import {
  ThingSpaceType,
  IThingSpaceGraphRequestSave,
  IGraphSkillRequestSave,
} from "@skills-app/models/thingspaceGraph";

const prefix = "[ThingSpace Page]";

export const loadPage = createAction(`${prefix} Load Page`);

export const switchThingSpaceType = createAction(
  `${prefix} Load Revisions`,
  props<{ thingSpaceType: ThingSpaceType }>(),
);

export const requestSaveTextBox = createAction(
  `${prefix} Request Save Text Box`,
  props<{
    thingSpaceId: string;
    newThingSpaceGraph: IThingSpaceGraphRequestSave;
  }>(),
);

export const requestUpsertGraphSkill = createAction(
  `${prefix} Request Upsert Graph Skill`,
  props<{ update: boolean; newGraphSkill: IGraphSkillRequestSave }>(),
);

export const requestDeleteGraphSkill = createAction(
  `${prefix} Request Delete Graph Skill`,
  props<{ thingSpaceId: string; skillNodeId: string }>(),
);

export const requestPublishThingSpace = createAction(
  `${prefix} Request Publish ThingSpace`,
  props<{
    thingSpaceId: string;
    newThingSpaceGraph: IThingSpaceGraphRequestSave;
  }>(),
);

export const requestUpdateGraphSkill = createAction(
  `${prefix} Request Update Graph Skill`,
  props<{
    thingSpaceId: string;
    skillNodeId: string;
    newGraphSkill: IGraphSkillRequestSave;
  }>(),
);

// for loading a draft //
export const requestLoadEditPage = createAction(
  `${prefix} Request Load Edit Page`,
  props<{ thingSpaceType: ThingSpaceType }>(),
);

export const clearDraft = createAction(`${prefix} Draft Cleared From Store`);

export const editorDirty = createAction(`${prefix} Editor Dirty`);

export const selectSkill = createAction(
  `${prefix} Select Skill`,
  props<{ skillId: string }>(),
);
